import { PurchaseDetail, PurchaseFormValues } from '../../types/purchases/BasePurchase';

export function mapCreditNotePurchaseToFormValues(purchase: PurchaseDetail): PurchaseFormValues {
  const creditNote = purchase.creditNoteDetails;

  const taxableSubtotal = creditNote?.taxableSubtotal ?? 0;
  const perceivedIVA = creditNote?.perceivedIVA ?? 0;
  const totalToRefund = creditNote?.totalToRefund ?? null;

  return {
    id: purchase.id,
    documentType: purchase.documentType,
    documentNumber: purchase.documentNumber,
    purchaseDate: purchase.purchaseDate,
    supplier: purchase.supplier,
    comments: purchase.comments || '',
    cancellationReason: purchase.cancellationReason || '',
    products: creditNote?.products || [],
    paymentCondition: purchase.paymentCondition || null,

    creditDueDate: '',
    creditDays: 0,
    totalQuantity: null,
    netAmount: null,
    freight: null,
    insurance: null,
    fauca: null,
    otherCosts: null,
    exportIva: null,
    totalCost: null,

    // Totales ajustados para la nota de crédito
    taxableSubtotal,
    perceivedIVA,
    totalToRefund,

    // 🧾 Se deja withheldIVA en 0, ya que no aplica a nota de crédito
    withheldIVA: 0,
  };
}
